<template>
  <label class="custom-checkbox">
    <input
      :id="id"
      type="checkbox"
      :checked="isChecked"
      :name="name"
      :disabled="disabled || (isForceSelect && isChecked)"
      @input="(e: any) => $emit('update:isChecked', e.target.checked)"
    />
    <span
      :class="`checkmark`"
      :data-cy="`custom-table-can-drag-drop-custom-check-box-${type}`"
      :style="`height: ${size};width: ${size}; background-color: ${bgColor}`"
    />
    <span class="title">{{ title }}</span>
  </label>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({
  emits: ["update:isChecked"],
})
export default class CustomCheckbox extends Vue {
  @Prop({ required: false, default: "" }) public title!: string;
  @Prop({ default: false }) public isChecked!: boolean;
  @Prop({ default: false }) public disabled?: boolean;
  @Prop({ required: false, default: "" }) readonly id: string = "";
  @Prop({ required: false, default: "" }) readonly type: string = "";
  @Prop({ required: false, default: "" }) readonly name: string = "";
  @Prop({ required: false, default: "24px" }) readonly size: string = "24px";
  @Prop({ required: false, default: "transparent" }) readonly bgColor: string =
    "";
  @Prop({ required: false, default: false })
  readonly isForceSelect: boolean = false;
  @Prop({ required: false, default: "#387dff" })
  readonly colorCheckmark: string = "";
  @Prop({ required: false, default: "40px" })
  public paddingLeftCheckbox = "40px";
}
</script>

<style scoped>
.custom-checkbox {
  position: relative;
  padding-left: v-bind(paddingLeftCheckbox);
  margin-bottom: 15px;
  cursor: pointer;
  font-size: 18px;
  user-select: none;
  display: flex;
  align-items: center;
}

.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  left: 0;
  border: 1.5px solid #dbdbdb;
  border-radius: 50%;
}

.checkmark::after {
  content: "";
  position: absolute;
  display: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -56%) rotate(45deg);
  width: 5px;
  height: 11px;
  border: solid v-bind(colorCheckmark);
  border-width: 0 2px 2px 0;
}

.custom-checkbox input:checked ~ .checkmark::after {
  display: block;
}

.custom-checkbox input:checked ~ .checkmark {
  background-color: transparent;
  border: 1.5px solid v-bind(colorCheckmark);
}

.title {
  color: var(--ui-dark, #231f20);
  /* text/text-13_med */
  font-size: 13px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  position: relative;
  top: 2px;
}
</style>
